import { IMAGE_BASE_URL } from '../../AppConfig';

export const giftIcon = `${IMAGE_BASE_URL}home/giftIcon.svg`;
export const BG_header = `${IMAGE_BASE_URL}home/BG_header.svg`;

export const Bullet = `${IMAGE_BASE_URL}ui/Bullet.svg`;
export const TnC = `${IMAGE_BASE_URL}ui/TnC.svg`;
export const infoBlack = `${IMAGE_BASE_URL}ui/infoBlack.svg`;

export const info = `${IMAGE_BASE_URL}win/info.svg`;

// export const CardGrass = `${IMAGE_BASE_URL}card/Card-Grass.svg`;
// export const CardForest = `${IMAGE_BASE_URL}card/Card-Forest.svg`;
// export const CardPurple = `${IMAGE_BASE_URL}card/Card-Purple.svg`;
// export const CardPink = `${IMAGE_BASE_URL}card/Card-Pink.svg`;

export default giftIcon;
